import React from 'react'
import bandPic from '../assets/images/band-ds.png'

class Header extends React.Component {
    render() {
        return (
            <section id="header">
                <div className={"grid-wrapper"}>
                    <div className="col-12 inner">
                        <h1>Geezer</h1>

                        <img src={bandPic} alt={"Members of Geezer"} className={"actions"} id={"bandPic"}/>
                        <div className="actions scrolly button">
                            The UK's most enthusiastic weezer tribute?
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Header
